import React, { Component } from 'react';
import Joi from 'joi-browser';
import {Input, TextArea } from './input';

class Form extends Component {
    state = { 
        data:{},
        errors:{}
     }

     validate = () =>{

        const opts ={
            abortEarly:false
        }
        const {error} = Joi.validate(this.state.data, this.schema, opts);

        if(!error)return null;

        const errors = {};
        for(let item of error.details)
            errors[item.path[0]] = item.message;
        return errors;
        
    };

    validateProperty = ({name,value}) => {

        const obj = {[name]: value};
        const schema = {[name]: this.schema[name]}   // [] is es6 computed property
        const {error} = Joi.validate(obj, schema);        
        return error ? error.details[0].message : null;
    }

    handleSubmit=e=>{
        e.preventDefault();
        
        const errors = this.validate();
        this.setState({errors: errors || {} }); // if errors is null set empty object
        if(errors)return;

        this.doSubmit();
    }
 
    handleChange = ({currentTarget: input}) =>{ // deconstruct e for currentTarget prop and alias it as input
        const errors = {...this.state.errors};

        const errorMessage = this.validateProperty(input);
        if(errorMessage)errors[input.name] = errorMessage;
        else delete errors[input.name];

        var data = {...this.state.data};
        data[input.name] = input.value;
        this.setState({data, errors});
    }

    renderButton(label){


       return <button disabled={this.validate()} className="btn btn-primary">{label}</button>
    }

    renderInput(name, label, type = "text")
    {
        const {data, errors} = this.state;
      return <Input type={type} error={errors[name]} name={name} value={data[name]} label={label} onChange={this.handleChange}></Input>;
    }

    renderTextArea(name, label, type = "text") {
      const { data, errors } = this.state;
      return <TextArea type={type} error={errors[name]} name={name} value={data[name]} label={label} onChange={
this.handleChange}></TextArea>;
    }
}
 
export default Form;